export default __webpack_public_path__ + "static/media/logo2.c822e7c2.png";